import $ from 'jquery';
import 'slick';
import { 
    slickCommonOptions,
} from './../../scripts/config';

/**
 * PromotionSliderV1 widget configs
 */
const promotionSliderV1Semantics = {
    'mainWrapClass': 'promotion-slider-v1',
    'instanceIdAttribute': 'data-instance-id',
    'isInitializedAttribute': 'data-is-initialized',
    'commonPluginOptionsAttribute': 'data-common-plugin-options',
    'sliderElementClass': 'promotion-slider-v1__tracker-wrap'
};

/**
 * PromotionSliderV1 initializer
 */
$(function() {

    if ($(`.${promotionSliderV1Semantics.mainWrapClass}`).length === 0) {
        return false;
    }

    let promotionSliderV1 = new PromotionSliderV1();

    /**
     * Checking other instances
     */
    
    $(`.${promotionSliderV1Semantics.mainWrapClass}`).each((index, el) => {
        let isInitialized = 
            ($(el).attr(`${promotionSliderV1Semantics.isInitializedAttribute}`) === 'true');
        if (!isInitialized) {
            promotionSliderV1.registerInstance($(el));
        }
    });

});

class PromotionSliderV1
{
    // not install @babel/plugin-proposal-class-properties
    // init properties in constructor
    constructor() {
        this.pluginInstances = {};
    }

    /**
     * Register instance
     * @param JQuery element
     * @throws
     */
    registerInstance(el) {
        let instanceId = 
            el.attr(`${promotionSliderV1Semantics.instanceIdAttribute}`) || false;

        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }
        let commonPluginOptions = 
            el.data(
                `${promotionSliderV1Semantics.commonPluginOptionsAttribute}`.replace('data-', '')
            ) || {};


        let pluginOptions = Object.assign({},
            slickCommonOptions,
            commonPluginOptions,
            {
                arrows: false,
                variableWidth: true,
                mobileFirst: true,
                swipeToSlide: true,
                infinite: true,
            }
        );
        el.show();
        try {
            // TODO[dependDetected]: slick plugin
            // the better solution: impl pluginProvider
            let slick = el.find(
                `.${promotionSliderV1Semantics.sliderElementClass}`
            ).slick(pluginOptions);
            el.attr(`${promotionSliderV1Semantics.isInitializedAttribute}`, true);
            this.pluginInstances[instanceId] = slick;
        } catch(e) {
            el.hide();
            throw e;
        }
    }
}